import styled from "styled-components";

export const H4Component = styled.h2`
    font-weight: 700;
    font-size: 12px;
    color: var(--text-color);
`